export default "__VITE_ASSET__DFrV3cjx__"